import axios from '../../../api/axiosInstance';

export const FETCH_PROMOTION_PACKAGES_SUCCESS = 'FETCH_PROMOTION_PACKAGES_SUCCESS';
export const FETCH_MY_PROMOTIONS_SUCCESS = 'FETCH_MY_PROMOTIONS_SUCCESS';
export const PROMOTION_LOADING = 'PROMOTION_LOADING';
export const PROMOTION_ERROR = 'PROMOTION_ERROR';

export const FETCH_AVAILABLE_SPACES_SUCCESS = 'FETCH_AVAILABLE_SPACES_SUCCESS';
export const CLEAR_AVAILABLE_SPACES = 'CLEAR_AVAILABLE_SPACES';

export const promotionMatchesMarket = (promotion, country) => {
    if (!country) return true;
    const market = String(country).toUpperCase();
    const promoCountry = promotion?.country || promotion?.countryCode || promotion?.marketCountry;
    if (!promoCountry) return true;
    return String(promoCountry).toUpperCase() === market;
};

export const spaceMatchesMarket = (space, country) => {
    if (!country) return true;
    const market = String(country).toUpperCase();
    const spaceCountry = space?.location?.country || space?.country;
    if (!spaceCountry) return true;
    return String(spaceCountry).toUpperCase() === market;
};

export const fetchAvailableHostSpaces = (hostEmail, packageId = null, country = null) => async (dispatch) => {
    dispatch({ type: CLEAR_AVAILABLE_SPACES });
    dispatch({ type: PROMOTION_LOADING });
    try {
        const url = `space/host-promotions/available-spaces/${hostEmail}${packageId ? `?packageId=${packageId}` : ''}`;
        const response = await axios.get(url);
        let spaces = response.data || [];
        if (country && Array.isArray(spaces)) {
            spaces = spaces.filter((space) => spaceMatchesMarket(space, country));
        }
        dispatch({ type: FETCH_AVAILABLE_SPACES_SUCCESS, payload: spaces });
    } catch (error) {
        dispatch({ type: PROMOTION_ERROR, payload: error.message });
    }
};

export const fetchActivePackages = (country) => async (dispatch) => {
    dispatch({ type: PROMOTION_LOADING });
    try {
        const params = country ? { country: String(country).toUpperCase() } : undefined;
        const response = await axios.get('space/promotion-packages/active', { params });
        let packages = response.data || [];
        if (country && Array.isArray(packages)) {
            const market = String(country).toUpperCase();
            packages = packages.filter((pkg) => !pkg.country || String(pkg.country).toUpperCase() === market);
        }
        dispatch({ type: FETCH_PROMOTION_PACKAGES_SUCCESS, payload: packages });
    } catch (error) {
        dispatch({ type: PROMOTION_ERROR, payload: error.message });
    }
};

export const fetchMyPromotions = (hostId, country = null) => async (dispatch) => {
    dispatch({ type: PROMOTION_LOADING });
    try {
        const response = await axios.get(`space/host-promotions/host/${hostId}`);
        let promotions = response.data || [];
        if (country && Array.isArray(promotions)) {
            promotions = promotions.filter((promotion) => promotionMatchesMarket(promotion, country));
        }
        dispatch({ type: FETCH_MY_PROMOTIONS_SUCCESS, payload: promotions });
        return promotions;
    } catch (error) {
        dispatch({ type: PROMOTION_ERROR, payload: error.message });
        throw error;
    }
};

export const initiatePromotionPurchase = (bookingData) => async (dispatch) => {
    try {
        const response = await axios.post('space/host-promotions/purchase', bookingData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const submitPromotionStripePayment = (paymentDetails) => async (dispatch) => {
    try {
        const response = await axios.post('pay/global/client/promotion-payment', paymentDetails);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updatePromotionPayment = (bookingId, status, paymentRef) => async (dispatch) => {
    try {
        const response = await axios.put(`space/host-promotions/${bookingId}/payment-status`, null, {
            params: { status, paymentRef }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const FETCH_PROMOTION_ANALYTICS_SUCCESS = 'FETCH_PROMOTION_ANALYTICS_SUCCESS';

export const fetchPromotionAnalytics = (id) => async (dispatch) => {
    dispatch({ type: PROMOTION_LOADING });
    try {
        const response = await axios.get(`space/host-promotions/${id}/analytics`);
        dispatch({ type: FETCH_PROMOTION_ANALYTICS_SUCCESS, payload: response.data });
        return response.data;
    } catch (error) {
        dispatch({ type: PROMOTION_ERROR, payload: error.message });
        return null;
    }
};
